export const decision_slice_name = 'DECISION';

export const STANDARD_DECISION = 'standardterms';
export const VALID_DECISIONS = ['standardterms', 'nonstandardterms'];
export const UW_DECISIONS = ['manualuw', 'additionalevidence'];
export const DECLINE_DECISIONS = ['declined', 'postponed'];
export const CONDITION_DECISIONS = [
  'nonstandardterms',
  'additionalevidence',
  'manualuw',
];

export const APPLICANT_UW_DECISION = 'referredtouw';

export const decision_thunks = {
  DECISION_GET_APPLICANT_DECISION_QUOTE: `${decision_slice_name}/getApplicantDecisionQuote`,
  DECISION_POST_DECISION_QUOTE: `${decision_slice_name}/postDecisionQuote`,
  DECISION_POST_REMOVEAPPLICANTATDECISION: `${decision_slice_name}/postRemoveApplicantAtDecision`,
};
